import {urls, api} from '@/api'
import * as types from '@/store/mutation-types'

const getInitialState = () => ({

  // Common
  sales: [],

  // Filters
  aggregations: {},

  // Paginator
  page: 1,
  per_page: 25,
  totalPages: null,
  totalSales: null,

})

const state = getInitialState()

const actions = {

  fetchSales: ({commit, state}, params = {}) => {

    // set paginator parameters
    if (params.page) {
      commit(types.SALES_LIST_SET_PAGE, params.page)
    } else {
      params.page = state.sales_page
    }
    params.per_page = state.sales_per_page

    return api.get(urls.userSales, { params })
      .then(({data}) => {

        // TODO: make searches and filters
        const aggregations = Array.isArray(data.aggregations) ? {} : data.aggregations

        commit(types.SALES_LIST_SET_SALES, data.data)
        commit(types.SALES_LIST_SET_PAGE, data.meta.pagination.page)
        commit(types.SALES_LIST_SET_TOTAL_PAGES, data.meta.pagination.total_pages)
        commit(types.SALES_LIST_SET_TOTAL_SALES, data.meta.pagination.total)
        commit(types.SALES_LIST_SET_AGGREGATIONS, aggregations)

      })
      .catch(er => {})
  },

  setPage: ({commit}, page) => { commit(types.SALES_LIST_SET_PAGE, page) },
}

const mutations = {


  [types.SALES_LIST_SET_SALES] (state, sales) {
    state.sales = sales
  },

  [types.SALES_LIST_SET_PAGE] (state, page) {
    state.page = parseInt(page)
  },

  [types.SALES_LIST_SET_TOTAL_PAGES] (state, total) {
    state.totalPages = total
  },

  [types.SALES_LIST_SET_TOTAL_SALES] (state, total) {
    state.totalSales = total
  },

  [types.SALES_LIST_SET_AGGREGATIONS] (state, total) {
    state.aggregations = total
  }

}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sales-list.js